import { forwardRef } from 'react';

interface ForwardRefProps {
  children: JSX.Element | JSX.Element[];
}

export const ForwardRefDiv = forwardRef<HTMLDivElement, ForwardRefProps>(
  ({ children }, ref) => {
    return <div ref={ref}>{children}</div>;
  }
);
